<template>
  <div class="quiz-static __container">
    <div class="quiz-static __image">
      <img v-if="image" :src="image">
      <slot name="image" />
    </div>
    <slot name="body" />
    <div class="quiz-static __heading">
      <span class="bold">{{ heading }}</span>
      <span class="pl-2" v-if="emojiHeading">{{ emojiHeading }}</span>
    </div>
    <div v-html="textHTML" class="quiz-static __text" />
  </div>
</template>
<script>
export default {
  props: {
    image: {
      type: String,
      default: null,
    },
    heading: {
      type: String,
      default: '',
    },
    emojiHeading: {
      type: String,
      default: '',
    },
    textHTML: {
      type: String,
      default: '',
    },
  },
}
</script>
<style lang="scss" scoped>
.quiz-static {
  &.__container {
    padding: 0 20px;
  }
  &.__image {
    padding-bottom: 1rem;
    img {
      height: 110px;
    }
  }
  &.__heading {
    margin-bottom: 0.25rem;
    margin-top: 0;
    font-size: 24px;
  }
  &.__text {
    line-height: 1.5;
    & /deep/ p {
      margin-top: 0;
    }
  }
}
</style>
